import 'nodelist-foreach-polyfill';
import 'lazyload';

declare const lazyload: any;

/**
 * Lazyload
 */
export class Lazyload {

  /**
   * Lazyloadオブジェクト
   */
  private readonly object: any;

  /**
   * コンストラクタ
   * @param selector 対象の要素セレクタ
   */
  constructor(selector: string) {
    this.object = lazyload(document.querySelectorAll(selector));
  }

  /**
   * すべてのイメージのロードを強制
   */
  public loadImages(callback: any): void {
    $(window).on('load', (): void => {
      this.object.loadImages();
      callback();
    });
  }

  /**
   * プラグインを破棄してlazyloadingを停止
   */
  public destroy(): void {
    this.object.destroy();
  }

  /**
   * イメージをロードしたのちプラグインを破棄してlazyloadingを停止
   */
  public loadAndDestroy(): void {
    this.object.loadAndDestroy();
  }

}
